var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 638,
    viewBox: "0 0 1920 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 638,
    fill: "url(#paint0_linear_2223_367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2223_367",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E92175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2891"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBg);
export default __webpack_public_path__ + "static/media/RedBg.7c3c3c187c3dd016be43f64a37054dfe.svg";
export { ForwardRef as ReactComponent };